import { render, staticRenderFns } from "./retailerMultiselect.vue?vue&type=template&id=7bbc3e0e"
import script from "./retailerMultiselect.vue?vue&type=script&lang=js"
export * from "./retailerMultiselect.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports